module.exports = __webpack_public_path__ + "static/media/section2.cd11eeb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/section2.jpg
// module id = 30
// module chunks = 0